import { ITrackableObject, createTrackableObject } from '@src/service/util/tracking/tracking';
import { ILemonEvent } from '@src/service/util/event/lemonEvent';

// callback event object type
export type ITrackableEvent<T> = ILemonEvent<T> & ITrackableObject<T>;

/** Enhance event object with event tracker. */
export function createTrackableEvent<T, P = ILemonEvent<any>>(event: ILemonEvent<T>, trackingParent?: P): ITrackableEvent<T> {
  return createTrackableObject<ILemonEvent<T>>(event, trackingParent);
}
